import React from 'react'
import styles from './index.module.css'
import Typography from '../../Typography'
import type { UtilityClassNames } from '@s4l/utility-css'
import { cn } from '@s4l/utility-css'

interface SpinnerProps {
  text: string
  className?: UtilityClassNames
  position?: {
    top?: string
    bottom?: string
    left?: string
    right?: string
    transform?: string
  }
}

export function Spinner({ text, className, position }: Readonly<SpinnerProps>) {
  return (
    <div
      className={cn(styles.loader, className, {
        [styles.hasPosition]: !!position,
      })}
      style={position}
      data-testid="loader"
    >
      <div className={styles.spinner} />
      <Typography variant="body" size="l" bold className={['display-none', 'tablet:display-block']}>
        {text}
      </Typography>
    </div>
  )
}
